import {atom, useAtomValue, useSetAtom} from 'jotai';
import {useAtomCallback} from 'jotai/react/utils';
import {useCallback, useEffect} from 'react';

import {AdFoxScriptState, AdFoxStatsEvent} from './types';

export const adFoxStatsEvents = atom<Array<AdFoxStatsEvent>>([]);

export const adFoxHasAds = atom<boolean>(false);

export const adFoxScriptState = atom<AdFoxScriptState>('not_initialized');

export const useAddAdFoxStatEvent = () => {
  const set = useSetAtom(adFoxStatsEvents);
  return useCallback(
    (event: AdFoxStatsEvent) => {
      set((current) => [...current, event]);
    },
    [set],
  );
};

export const useConsumeAdFoxStatEvents = () =>
  useAtomCallback(
    useCallback((get, set) => {
      const q = get(adFoxStatsEvents);
      set(adFoxStatsEvents, []);
      return q;
    }, []),
  );

export const useIsScriptLoaded = () =>
  useAtomValue(adFoxScriptState) === 'loaded';

export const useAwakenController = (enabled = true) => {
  const setHasAds = useSetAtom(adFoxHasAds);
  useEffect(() => {
    if (!enabled) {
      return;
    }
    setHasAds(true);
  }, [enabled, setHasAds]);
};
